
import apiClient from "../../helpers/axios";

/*
 * Визитки (двусторонние). BACKEND: controller/printCard.controller.js, маршруты — в routes/printSign.js.
 * Данные фирмы — из профиля бренда (как у вывесок), библиотека картинок — общая.
 */
const base = "/admin/print-cards";

const IMAGE_DEFAULTS = { assetId: null, scale: 1, offsetX: 0, offsetY: 0, darken: 0 };
const PART = { s: 1, x: 0, y: 0 };

export const FRONT_PARTS = ["logo", "name", "tagline"];
export const BACK_PARTS = ["person", "contacts", "qr"];
export const PART_LABELS = { logo: "Логотип", name: "Название фирмы", tagline: "Подпись", person: "ФИО и должность", contacts: "Контакты", qr: "QR-код" };
/** Какой флаг «показывать» у куска (глаз). */
export const PART_SHOW = { logo: "logo", name: "name", tagline: "tagline", person: "person", contacts: "contacts", qr: "qr" };

export const EMPTY_CARD_DRAFT = {
    name: "",
    profileId: null,
    size: { preset: "ru", widthMm: 90, heightMm: 50, orientation: "horizontal", bleedMm: 2, cropMarks: true },
    design: "granite-gold",
    colors: { background: "#101214", accent: "#c9a35a", text: "", texture: "stone" },
    frame: true,
    person: { name: "", position: "", phones: [], emails: [] },
    qrUrl: "",
    qrCaption: "",
    front: {
        layout: "center",
        show: { logo: true, name: true, tagline: true },
        parts: { logo: { ...PART }, name: { ...PART }, tagline: { ...PART } },
        background: { ...IMAGE_DEFAULTS },
    },
    back: {
        layout: "contacts",
        show: { person: true, contacts: true, phones: true, emails: true, addresses: true, site: true, hours: false, qr: true },
        parts: { person: { ...PART }, contacts: { ...PART }, qr: { ...PART } },
        background: { ...IMAGE_DEFAULTS },
    },
};

const side = (value = {}, empty) => ({
    layout: value.layout || empty.layout,
    show: { ...empty.show, ...(value.show || {}) },
    parts: Object.keys(empty.parts).reduce((result, key) => ({ ...result, [key]: { ...PART, ...(value.parts?.[key] || {}) } }), {}),
    background: { ...IMAGE_DEFAULTS, ...(value.background || {}) },
});

/** Только то, что можно менять в визитке, — это и уходит на сервер. */
export const toCardDraft = (card) => ({
    name: card.name || "",
    profileId: card.profileId || null,
    size: { ...EMPTY_CARD_DRAFT.size, ...(card.size || {}) },
    design: card.design || "granite-gold",
    colors: { ...EMPTY_CARD_DRAFT.colors, ...(card.colors || {}) },
    frame: card.frame !== false,
    person: {
        name: card.person?.name || "",
        position: card.person?.position || "",
        phones: [...(card.person?.phones || [])],
        emails: [...(card.person?.emails || [])],
    },
    qrUrl: card.qrUrl || "",
    qrCaption: card.qrCaption || "",
    front: side(card.front, EMPTY_CARD_DRAFT.front),
    back: side(card.back, EMPTY_CARD_DRAFT.back),
});

export const getCardMeta = async () => (await apiClient.get(`${base}/meta`)).data;

export const listCards = async () => {
    const response = await apiClient.get(base);
    return Array.isArray(response.data?.cards) ? response.data.cards : [];
};
export const getCard = async (cardId) => (await apiClient.get(`${base}/${cardId}`)).data.card;
export const createCard = async (draft) => (await apiClient.post(base, draft)).data.card;
export const updateCard = async (cardId, draft) => (await apiClient.patch(`${base}/${cardId}`, draft)).data.card;
export const deleteCard = async (cardId) => (await apiClient.delete(`${base}/${cardId}`)).data;
export const duplicateCard = async (cardId) => (await apiClient.post(`${base}/${cardId}/duplicate`)).data.card;
/** Собрать PDF (лицо + оборот), лист A4 и PNG. */
export const buildCard = async (cardId) => (await apiClient.post(`${base}/${cardId}/build`, {}, { timeout: 180000 })).data.card;
/** format: pdf (типография) | sheet (лист A4) | png (мессенджеры). */
export const fetchCardFile = async (cardId, fileId, format) => (
    await apiClient.get(`${base}/${cardId}/files/${fileId}/${format}`, { responseType: "blob" })
).data;

/** Обе стороны по тому, что на экране: { front: { image, layout }, back: { … }, warnings }. */
export const previewCard = async ({ cardId = "", card, profileId = "", profile = null, width = 900 }) => (
    await apiClient.post(`${base}/preview`, { cardId, card, profileId, profile, width }, { timeout: 120000 })
).data;
